import { ApolloClient, from } from '@apollo/client';

import { cache } from 'config/graphql/cache/cache';
import { rankingAuthLink } from 'config/graphql/links/authLink';
import { rankingsLink } from 'config/graphql/links/common';

export const rankingsCilent = () => {
  return new ApolloClient({
    link: from([rankingAuthLink, rankingsLink]),
    cache,
    connectToDevTools: true,
  });
};
